<h2 mat-dialog-title>Detalhes da Nota Fiscal</h2>
<mat-dialog-content class="nota-fiscal-details">
  @if (data.nota) {
    <div>
      <h3>Informações Gerais</h3>
      <div class="detail-grid">
        <div class="detail-item">
          <strong>Número NF:</strong> {{ data.nota.numeroNotaFiscal || "N/A" }}
        </div>
        <div class="detail-item">
          <strong>Data Emissão:</strong>
          {{ data.nota.dataEmissaoNotaFiscal | date : "dd/MM/yyyy" }}
        </div>
        <div class="detail-item">
          <strong>Valor Total:</strong>
          {{ data.nota.valor | currency : "BRL" }}
        </div>
        @if (data.nota.linkArquivoNotaFiscal) {
          <div class="detail-item">
            <strong>Arquivo:</strong>
            <a
              [href]="data.nota.linkArquivoNotaFiscal"
              target="_blank"
              mat-raised-button
              color="primary"
              >
              <mat-icon>cloud_download</mat-icon> PDF
            </a>
            <a
              style="margin-left: 10px"
              [href]="data.nota.linkArquivoXmlNotaFiscal"
              target="_blank"
              mat-raised-button
              color="primary"
              >
              <mat-icon>cloud_download</mat-icon> XML
            </a>
          </div>
        }
      </div>
      @if (data.nota.fornecedor) {
        <h3>Serviço</h3>
      }
      @if (data.nota.fornecedor) {
        <div class="detail-grid">
          <div class="detail-item">
            <strong>Nome:</strong>
            {{
            data.nota.fornecedor.nomeEmpresa || data.nota.fornecedor.nome || "N/A"
            }}
          </div>
          @if (data.nota.tipoManutencao.nome) {
            <div class="detail-item">
              <strong>Tipo Manutenção:</strong>
              {{ data.nota.tipoManutencao.nome || "N/A" }}
            </div>
          }
          @if (data.nota.tipoServicoNome) {
            <div class="detail-item">
              <strong>Tipo Serviço:</strong> {{ data.nota.tipoServicoNome || "N/A" }}
            </div>
          }
          @if (data.nota.descricao) {
            <div class="detail-item">
              <strong>Descrição:</strong> {{ data.nota.descricao || "N/A" }}
            </div>
          }
        </div>
      }
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Fechar</button>
</mat-dialog-actions>
